var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    viewBox: "0 0 18 18",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.293 1.293A1 1 0 001 2v2a1 1 0 001 1h14a1 1 0 001-1V2a1 1 0 00-1-1H2a1 1 0 00-.707.293zM1.293 9.293A1 1 0 001 10v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1H2a1 1 0 00-.707.293zM13.293 9.293A1 1 0 0013 10v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2a1 1 0 00-.707.293z",
    strokeWidth: 1.67
  })));
}
export default __webpack_public_path__ + "static/media/notice.b27a4e40.svg";
export { SvgNotice as ReactComponent };